module.exports = __webpack_public_path__ + "static/media/arrow-box-icon.ca428b92.svg";